// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { VhostBindingSourceSchema } from '../inputTypeSchemas/VhostBindingSourceSchema'

/////////////////////////////////////////
// VHOST BINDING SCHEMA
/////////////////////////////////////////

export const VhostBindingSchema = z.object({
  source: VhostBindingSourceSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  domainId: z.string(),
  hostId: z.string().nullable(),
  gatewayId: z.string().nullable(),
  networkServiceId: z.string().nullable(),
  listenerKey: z.string(),
  evidence: z.string().nullable(),
  lastSeenAt: z.coerce.date(),
  vhostEnumCompletedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type VhostBinding = z.infer<typeof VhostBindingSchema>

export default VhostBindingSchema;
